import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TicketWalletBalanceLeg } from '@hypenation/tickets';
import { TicketWithOrder } from '../../services/my-tickets-loader.service';

export interface TicketDetailModalData {
  ticket: TicketWithOrder;
  balances: TicketWalletBalanceLeg[];
  hasWallet: boolean;
  downloadUrl: string;
}

/**
 * Everything about one ticket, for a customer who tapped its card.
 *
 * A modal rather than a route: the shared ticket routes already own `tickets/:slug/:token` and
 * `tickets/:slug/:uuid/:eventTypeUid`, so a `tickets/:uid` detail path would be ambiguous with
 * them. A modal also keeps the customer's place in the list they were scanning.
 */
@Component({
  selector: 'hypenation-ticket-detail-modal',
  standalone: true,
  imports: [CommonModule, RouterModule, NzButtonModule, NzIconModule],
  templateUrl: './ticket-detail-modal.component.html',
  styleUrl: './ticket-detail-modal.component.css',
})
export class TicketDetailModalComponent {
  private readonly modalRef = inject(NzModalRef);
  readonly data = inject<TicketDetailModalData>(NZ_MODAL_DATA);

  get ticket(): TicketWithOrder {
    return this.data.ticket;
  }

  close(): void {
    this.modalRef.close();
  }
}
